/* eslint-disable react/require-default-props */
import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { BiddingChatTypes } from 'store/modules/bidding_chat/types';
import {
  BiddingSummaryCapagInfo,
  BiddingSummaryEditalDownload,
} from 'store/modules/bidding_summary_store/types';
import createTrack from 'services/actions/tracker_actions';
import { track } from 'services/tracking';
import iconIA from 'assets/images/icone-ia.svg';

interface BiddingChatButtonProps {
  biddingId: number;
  source: string;
  editalDownload?: BiddingSummaryEditalDownload;
  capagInfo?: BiddingSummaryCapagInfo;
}

const BiddingChatButton = (props: BiddingChatButtonProps) => {
  const { biddingId, source, editalDownload, capagInfo } = props;
  const dispatch = useDispatch();

  const [previousBiddingId, setPreviousBiddingId] = useState<number>(0);

  const openChat = () => {
    if (previousBiddingId !== biddingId && previousBiddingId !== 0)
      dispatch({ type: BiddingChatTypes.CLEAR_CURRENT_CHAT });

    if (previousBiddingId !== biddingId) setPreviousBiddingId(biddingId);

    dispatch({ type: BiddingChatTypes.OPEN_CHAT, biddingId, editalDownload, capagInfo });
  };

  return (
    <div className="d-inline-block mr-1 mb-1 position-relative">
      <button
        id={biddingId.toString()}
        type="button"
        className="btn btn-sm btn-primary d-flex btn-ia"
        onClick={() => {
          openChat();
          createTrack('Card - Clicou em Pergunte ao edital', { fonte: source });
          track('edital.clicou_pergunte_edital', { fonte: source, bidding_id: biddingId });
        }}
      >
        <img
          alt="Icone Consultor Jurídico"
          src={iconIA}
          height="18px"
          aria-hidden="true"
          className="mr-1"
        />
        Pergunte ao Edital
      </button>
    </div>
  );
};

export default BiddingChatButton;
